import React from 'react';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';

import { companyNames, proccessType } from '@domain/constants'



// // Sources
// const GOOGLE_ANALYTICS = 'https://*.google-analytics.com'; // https://developers.google.com/tag-platform/security/guides/csp#google_analytics_4_google_analytics
// const GOOGLE_GTM = 'https://*.googletagmanager.com';
// const GOOGLE_ANALYTICS_2 = 'https://*.analytics.google.com'

// const MAPS_GOOGLEAPIS = 'https://*.googleapis.com'; //https://developers.google.com/maps/documentation/javascript/content-security-policy
// const MAPS_GSTATIC = 'https://*.gstatic.com';
// const GOOGLE_FONTS = 'https://fonts.gstatic.com';
// const GOOGLE_FONTS_2 = 'https://fonts.googleapis.com'
// //const UNSAFE_EVAL = "'unsafe-eval'";
// const GOOGLE = 'https://*.google.com';

// const HOTJAR_DOMAIN = 'https://*.hotjar.com'; // https://help.hotjar.com/hc/en-us/articles/115011640307-Content-Security-Policies
// const HOTJAR_IO = 'https://*.hotjar.io'
// const HOTJAR_WSS = 'wss://*.hotjar.com'
// const UNSAFE_INLINE = "'unsafe-inline'";

// const DATADOG_LOGS = 'https://browser-intake-datadoghq.com'; // https://docs.datadoghq.com/integrations/content_security_policy_logs/?tab=firefox
// const DATADOG_RUM_LOGS = 'https://*.browser-intake-datadoghq.com'
// const BLOB = 'blob:';
// const DATA = 'data:';

// const IMAGE_COMPRESSION = 'https://cdn.jsdelivr.net'
// const CORE_PLATFORM = 'https://mijnschade.com https://openclaims.mendixcloud.com https://www.mijnschade.com https://accp.mijnschade.com https://staging.mijnschade.com/';

// const SELF = "'self' https://*.mijnschade.com https://*.accp.mijnschade.com https://*.mijnschades.com https://*.accp.mijnschades.com https://*.autotest.mijnschades.com https://*.staging.mijnschades.com"

// const content = `default-src ${SELF}; base-uri ${SELF}; script-src ${SELF} ${HOTJAR_DOMAIN} ${UNSAFE_INLINE} ${GOOGLE_GTM} ${MAPS_GOOGLEAPIS} ${MAPS_GOOGLEAPIS} ${GOOGLE} ${IMAGE_COMPRESSION}; style-src ${SELF} ${UNSAFE_INLINE} ${HOTJAR_DOMAIN} ${GOOGLE_FONTS_2}; img-src ${SELF} ${CORE_PLATFORM} ${HOTJAR_DOMAIN} ${GOOGLE_ANALYTICS} ${GOOGLE_GTM} ${MAPS_GSTATIC} ${MAPS_GOOGLEAPIS} ${GOOGLE} ${DATA} ${BLOB}; connect-src ${SELF} ${CORE_PLATFORM} ${HOTJAR_DOMAIN} ${HOTJAR_IO} ${HOTJAR_WSS} ${DATADOG_RUM_LOGS} ${DATADOG_LOGS} ${GOOGLE_ANALYTICS} ${GOOGLE_GTM} ${GOOGLE_ANALYTICS_2} ${MAPS_GSTATIC} ${MAPS_GOOGLEAPIS} ${GOOGLE} ${DATA} ${BLOB}; worker-src ${BLOB}; font-src ${SELF} ${UNSAFE_INLINE} ${HOTJAR_DOMAIN} ${GOOGLE_FONTS}; frame-src ${SELF} ${GOOGLE}`


function HtmlHead({
  faviconCustom,
}) {
  const insurer = useSelector(state => state.insurer)

  const chooseTitle = () => {
    if (insurer.objectType === companyNames.Schadegarant) {
      return { title: 'eXperience' }
    }
    if (insurer.objectType === proccessType.DI) {
      return { title: 'Digitale intake' }
    } if (insurer.objectType === proccessType.EM || (insurer.objectType === proccessType.Casco && insurer.brand === companyNames.Rhion)) {
      return { title: 'Uw schadebeschrijving' }
    } if (insurer.objectType === proccessType.Casco && (insurer.brand === companyNames.VIP || !insurer.brand)) {
      return { title: 'VIP Schadeservice' }
    } else {
      return { title: insurer.brandName || '' }
    }
  }

  const chooseFavicon = () => {
    if (insurer.objectType === companyNames.Schadegarant) {
      return { favicon: '/favicon_sg.ico' }
    }
    if (insurer.objectType === proccessType.DI) {
      return { favicon: '/favicon_akzo.ico' }
    }
    if (insurer.objectType === proccessType.EM || (insurer.objectType === proccessType.Casco && insurer.brand === companyNames.Rhion)) {
      return { favicon: '/favicon_rhion.ico' }
    }
    if (insurer.objectType === proccessType.Casco && (insurer.brand === companyNames.VIP || !insurer.brand)) {
      return { favicon: '/favicon_vip.ico' }
    }
    else {
      return { favicon: '/favicon.ico' }
    }
  }

  if (!insurer) {
    return (
      <Helmet>
      </ Helmet>
    )
  }
  return (
    <Helmet>
      <title>{chooseTitle().title}</title>
      <link rel="shortcut icon" href={!!faviconCustom ? 'data:image/x-icon;base64,' + faviconCustom : chooseFavicon().favicon} />
    </Helmet>
  );
};


export default HtmlHead;
